import { INTERVIEW_STAGES, MONTHS_SHORT, stageTitle, WAIT_STAGES } from '@jt/core';
import { useApplications } from '../api/hooks';
import { useUI } from '../components/overlays';
import { Empty, Icon, PageHead, StagePill } from '../components/ui';
import { useAi, useOpenDraft } from '../drafts/useDraft';

export function InterviewsPage() {
  const ui = useUI();
  const apps = useApplications();
  const ai = useAi();
  const openDraft = useOpenDraft();
  // список с сервера уже отсортирован по срочности (ближайшая дата шага выше)
  // предстоящие этапы и пройденные, по которым ждём итогов (они ниже: срочности нет)
  const L = (apps.data ?? []).filter(
    (a) => INTERVIEW_STAGES.includes(a.stage) || WAIT_STAGES.includes(a.stage),
  );
  const head = <PageHead title="Интервью" sub="Скрининги, технические и финальные этапы" />;
  if (apps.isPending) return head;
  if (!L.length)
    return (
      <>
        {head}
        <Empty
          title="Интервью пока нет"
          text="Когда вакансия перейдёт в «HR-скрининг» или «Интервью», она появится здесь с датой и планом подготовки."
        />
      </>
    );
  return (
    <>
      {head}
      <div className="list">
        {L.map((a) => {
          const c = a.contacts[0];
          const d = a.nextDate ? a.nextDate.split('-').map(Number) : null;
          return (
            <div className="lrow" key={a.id}>
              <div className={`datebox ${d ? '' : 'none'}`}>
                {d ? (
                  <>
                    <b>{d[2]}</b>
                    <span>{MONTHS_SHORT[d[1]! - 1]}</span>
                  </>
                ) : (
                  <>
                    <b>—</b>
                    <span>дата</span>
                  </>
                )}
              </div>
              <div
                className="lm clickable"
                role="button"
                tabIndex={0}
                onClick={() => ui.openApp(a.id)}
                onKeyDown={(e) => e.key === 'Enter' && ui.openApp(a.id)}
              >
                <b>{a.nextStep || stageTitle(a.stage)}</b>
                {a.nextTime && <span className="muted"> {a.nextTime}</span>}
                <div className="meta">
                  {a.company} · {a.role}
                  {c?.name ? ` · ${c.name}` : ''}
                </div>
                <StagePill stage={a.stage} />
              </div>
              <div className="btnrow" style={{ margin: 0 }}>
                {ai && (
                  <button className="btn sm" onClick={() => openDraft(a.id, 'prep')}>
                    <Icon name="sparkles" size={15} /> Подготовиться
                  </button>
                )}
                <button className="btn sm ghost" onClick={() => ui.openApp(a.id)}>
                  Открыть
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}
